var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7168 6.56992C19.7173 7.82243 19.2602 9.032 18.4316 9.97118C17.6029 10.9104 16.4596 11.5145 15.2168 11.6699C16.4591 10.2614 17.1446 8.44795 17.1446 6.56992C17.1446 4.69189 16.4591 2.87843 15.2168 1.46997C16.4596 1.62539 17.6029 2.22949 18.4316 3.16867C19.2602 4.10785 19.7173 5.31741 19.7168 6.56992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 21.1423V23.7147H20.5727V21.1423C20.5747 20.1677 20.3675 19.2041 19.9651 18.3165C19.5627 17.4289 18.9745 16.6381 18.2402 15.9973H18.8552C20.2198 15.9973 21.5284 16.5394 22.4933 17.5042C23.4581 18.4691 24.0002 19.7777 24.0002 21.1423Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8548 21.1423V23.7147H0V21.1423C0 19.7777 0.542056 18.4691 1.50692 17.5042C2.47179 16.5394 3.78042 15.9973 5.14495 15.9973H13.7174C15.0806 15.9993 16.3873 16.5422 17.3505 17.5069C18.3138 18.4715 18.8548 19.779 18.8548 21.1423Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4276 6.57001C15.4101 8.15585 14.7723 9.67178 13.6509 10.7932C12.5294 11.9146 11.0135 12.5524 9.42768 12.57C7.83639 12.57 6.31028 11.9378 5.18508 10.8126C4.05987 9.6874 3.42773 8.16129 3.42773 6.57001C3.42773 4.97873 4.05987 3.45262 5.18508 2.32741C6.31028 1.2022 7.83639 0.570068 9.42768 0.570068C11.0135 0.587615 12.5294 1.22538 13.6509 2.34681C14.7723 3.46824 15.4101 4.98417 15.4276 6.57001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer_icon.5abc34f7849ab5b3de50dc7f9178e23b.svg";
export { ForwardRef as ReactComponent };